import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {FormDialogComponent} from '@aviary/dialogs/form-dialog/form-dialog.component';
import {FormDialogDefinition} from '@aviary/dialogs/form-dialog/form-dialog.types';
import {PersistentFormDialogController} from '@aviary/dialogs/persistent-form-dialog/persistent-form-dialog.controller';
import {PersistentFormDialogDefinition} from '@aviary/dialogs/persistent-form-dialog/persistent-form-dialog.types';

@Component({
  selector: 'mx-persistent-form-dialog',
  host: {
    class: 'hk-delegate-vertical-scrolling grow'
  },
  template: `
    @let submitting = (controller.submitting | async) ?? false;

    <mx-form-dialog [definition]="persistentDefinition"
                    [closeOnConfirm]="false"
                    [enableCancelButton]="!submitting"
                    [enableConfirmButton]="submissionEnabled"
                    [confirmationPending]="submitting"
                    [showConfirmationPendingSpinner]="showConfirmationPendingSpinner">
      <ng-content/>
    </mx-form-dialog>
  `,
  /*
    eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
    -- Match FormDialogComponent so projected formGroup changes refresh confirmation-button enablement.
  */
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [AsyncPipe, FormDialogComponent]
})
export class PersistentFormDialogComponent<ValueType> {
  public readonly controller: PersistentFormDialogController<ValueType> = inject(PersistentFormDialogController);
  @Input() public submissionEnabled: boolean = true;

  @Input({required: true})
  public set definition(definition: PersistentFormDialogDefinition<ValueType>) {
    const {showConfirmationPendingSpinner = true, ...formDialogDefinition} = definition;

    this.showConfirmationPendingSpinner = showConfirmationPendingSpinner;
    this.persistentDefinition = {
      ...formDialogDefinition,
      onConfirm: () => this.controller.submit(definition.formGroup.value)
    };
  }

  public persistentDefinition: FormDialogDefinition<ValueType>;
  public showConfirmationPendingSpinner: boolean = true;
}
